import { PermissionGroupMessages, TranslationPermissionGroupMessages } from "../interfaces";

export const messages : TranslationPermissionGroupMessages = {
  [PermissionGroupMessages.generalRegistration]: "Registro general",
  [PermissionGroupMessages.supply]: "Suministro",
  [PermissionGroupMessages.concreteRecipeFamily]: "Familia de recetas de hormigón",
  [PermissionGroupMessages.administration]: "Administración",
  [PermissionGroupMessages.supplyQuality]: "Calidad de suministro",
  [PermissionGroupMessages.vehicles]: "Vehículos",
  [PermissionGroupMessages.employees]: "Empleados",
  [PermissionGroupMessages.report]: "Reporte",
  [PermissionGroupMessages.settings]: "Configuraciones",
  [PermissionGroupMessages.expedition]: "Expedición",
  [PermissionGroupMessages.schedule]: "Programación",
  [PermissionGroupMessages.userRightsControl]: "Control de derechos de usuario",
  [PermissionGroupMessages.batchPortalMaintenanceView]: "Mant. Visualizar",
  [PermissionGroupMessages.batchPortalMaintenanceEdit]: "Mant. Editar",
  [PermissionGroupMessages.batchPortalMaintenanceExecute]: "Mant. Ejecutar",
  [PermissionGroupMessages.batchPortalAutomationView]: "Autom. Visualizar",
  [PermissionGroupMessages.batchPortalAutomationExecute]: "Autom. Ejecutar",
  [PermissionGroupMessages.batchPortalAutomationAdmin]: "Autom. Admin",
  [PermissionGroupMessages.batchPortalAutomationSuperAdmin]: "Autom. Super Admin",
  [PermissionGroupMessages.dashboard]: "Panel",
  [PermissionGroupMessages.laboratory]: "Laboratorio"
};